import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { LookerAdminService } from 'src/app/services/looker-admin.service';

@Component({
  standalone: false,
  selector: 'app-rx-revcycle-summary',
  templateUrl: './rx-revcycle-summary.component.html',
  styleUrls: ['./rx-revcycle-summary.component.scss'],
})
export class RxRevcycleSummaryComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService,
    private route: ActivatedRoute,
    private lookerAdminService: LookerAdminService
  ) {}
  public loadingStatus: boolean;
  public serviceName: string = 'RXRevCycle';
  public pageSize = 10;
  public feature: string = 'UI::BusinessIntelligence::RxRevCycle';
  private routeSub: any;

  routeActivated = false;
  healthcareTopBarLoaded: Subscription;
  scroll: any;

  ngAfterViewInit(): void {
    const self = this;
    if (this.authorizationService.hasTopBarLoaded === true) {
      if (!this.authorizationService.hasFeature(this.feature)) {
        this.router.navigate(['/no-access']);
      }
    } else {
      this.healthcareTopBarLoaded =
        this.authorizationService.healthcareLoadedSubject$.subscribe(() => {
          if (!this.authorizationService.hasFeature(this.feature)) {
            this.router.navigate(['/no-access']);
          }
          self.healthcareTopBarLoaded.unsubscribe();
        });
    }
  }

  ngOnInit(): void {
    this.scroll = window.pageYOffset;
    const self = this;
  }
  // clean up to prevent memory leaks, by unsubscribing to subscribed events
  ngOnDestroy(): void {}
  // check if user has edit feature
  initialPageSetup(): void {}

  routeChanged(): void {
    this.routeActivated = true;
    if (this.authorizationService.HealthcareTopBar) {
      this.authorizationService.HealthcareTopBar.notifyActivity();
    }
  }

  sideNavDashboardItemsComplete($event) {
    this.lookerAdminService.sendMessage($event);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event): void {
    const prevScrollpos = window.pageYOffset;
    const currentScrollPos = window.pageYOffset;
    if (prevScrollpos <= 71) {
      document.getElementById('navbar').style.top = 71 - prevScrollpos + 'px';
    } else {
      document.getElementById('navbar').style.top = '0px';
    }
  }
}
